export default {
  form: {
    custom_tip: {
      validation: {
        max: '{{value}} is the max tip value',
      },
    },
  },
};
